'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  q: string;
  a: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
  className?: string;
}

export default function FAQAccordion({ items, className = '' }: FAQAccordionProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <div className={`space-y-3 ${className}`}>
      {items.map((faq, i) => (
        <div key={i} className="bg-card rounded-2xl border border-border overflow-hidden">
          <button
            onClick={() => setOpenIdx(openIdx === i ? null : i)}
            className="w-full flex items-center justify-between px-5 sm:px-6 py-4 sm:py-5 text-left gap-3"
            aria-expanded={openIdx === i}
          >
            <span className="font-heading font-semibold text-foreground text-sm leading-snug">{faq.q}</span>
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                openIdx === i ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}
            >
              <Icon
                name={openIdx === i ? 'MinusIcon' : 'PlusIcon'}
                size={16}
                className={openIdx === i ? 'text-white' : 'text-muted-foreground'}
              />
            </div>
          </button>
          <div
            className="overflow-hidden transition-all duration-300 ease-in-out"
            style={{ maxHeight: openIdx === i ? '300px' : '0' }}
          >
            <div className="px-5 sm:px-6 pb-5 text-sm text-muted-foreground leading-relaxed">{faq.a}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
